import type { ReactNode, SVGProps } from 'react'

/**
 * De sleepgreep: zes stippen op een 24-raster, in Lucide-stijl (ontwerp 10.2).
 *
 * Vervangt het brailleteken (⠿) dat hiervoor stond: functioneel identiek (decoratief,
 * `aria-hidden`), maar fontafhankelijk en niet in de gevraagde stijl. Altijd naast een
 * knop met zijn eigen `aria-label`; dit icoon draagt zelf geen betekenis.
 */
export function GripIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      // Inline en niet via een CSS-klasse: dit component wordt zowel geladen waar
      // schil.css als waar alleen tokens.css staat (de configurator), en de token zelf
      // is overal aanwezig.
      style={{ width: 'var(--nwo-space-sp-4)', height: 'var(--nwo-space-sp-4)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <circle cx="9" cy="6" r="1.5" />
      <circle cx="15" cy="6" r="1.5" />
      <circle cx="9" cy="12" r="1.5" />
      <circle cx="15" cy="12" r="1.5" />
      <circle cx="9" cy="18" r="1.5" />
      <circle cx="15" cy="18" r="1.5" />
    </svg>
  )
}
